
import { ATTR_TYPES } from './dataDefinition.js';

const DEFINITION_PAR = {
    objectType: 'par',
    tableName: 'iskn_parcely',
    title: 'Parcely',
    attributes: [
        {
            id: 'id',
            type: ATTR_TYPES.STRING,
            title: 'ID parcely'
        },
        {
            id: 'katuze_kod',
            type: ATTR_TYPES.INTEGER,
            title: 'Kód katastrálního území'
        },
        {
            id: 'par_type',
            type: ATTR_TYPES.INTEGER,
            title: 'Typ parcely',
            values: [
                ['PKN', 'PKN'],
                ['PZE', 'PZE'],
            ]
        },
        {
            id: 'parcela',
            type: ATTR_TYPES.STRING,
            title: 'Parcelní číslo',
            sqlField: `CASE WHEN poddeleni_cisla_par IS NOT NULL THEN kmenove_cislo_par || '/' || poddeleni_cisla_par ELSE kmenove_cislo_par::varchar END`
        },
        {
            id: 'drupoz_kod',
            type: ATTR_TYPES.INTEGER,
            title: 'Druh pozemku',
            values: [
                ['2', 'orná půda'],
                ['3', 'chmelnice'],
                ['4', 'vinice'],
                ['5', 'zahrada'],
                ['6', 'ovocný sad'],
                ['7', 'trvalý travní porost'],
                ['10', 'lesní pozemek'],
                ['11', 'vodní plocha'],
                ['13', 'zastavěná plocha a nádvoří'],
                ['14', 'ostatní plocha']
            ]
        }
    ]
};

export {
    DEFINITION_PAR
};
